export default __webpack_public_path__ + "static/media/victory_mark.40073466.png";